import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=ddc8d782&scoped=true&"
import script from "./Introduce.vue?vue&type=script&lang=js&"
export * from "./Introduce.vue?vue&type=script&lang=js&"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=ddc8d782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc8d782",
  null
  
)

export default component.exports